import React from 'react';

export function useIframeHead() {
  const [styleLinks, setStyleLinks] = React.useState<string[] | null>(null);
  React.useEffect(() => {
    const links: string[] = [];
    [...document.styleSheets].forEach((styleSheet) => {
      if (styleSheet.href) {
        links.push(styleSheet.href);
      }
    });
    setStyleLinks(links);
  }, []);
  return styleLinks?.reduce((acc, link) => {
    const linkHtml = `<link href="${link}" rel="stylesheet" type="text/css" >\n`;
    return acc + linkHtml;
  }, '');
}
